import React, {useState, useRef, useEffect} from "react";
import PropTypes from "prop-types";
import {message, Modal, Space, Button, Form, Row, Col, Input, InputNumber} from "antd";
import {FileDoneOutlined, CloseCircleOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./BannerModal.module.css";

const BannerModal = (props) => {
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);

    useEffect(() => {
        if (props.visible) {
            if (props.activityBanner) {
                setTimeout(() => {
                    form.setFieldsValue(props.activityBanner);
                }, 100);
            }
        } else {
            form.resetFields();
        }

        //eslint-disable-next-line
    }, [props.visible]);

    const handleCancelActivityBanner = () => {
        props.onClose();
    };

    const handleSubmitActivityBanner = () => {
        form.validateFields()
            .then((data) => {
                data.activityBannerId = props.activityBanner.activityBannerId;
                data.activityId = props.activityBanner.activityId;
                data.systemVersion = props.activityBanner.systemVersion;

                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                let url = "";
                if (props.activityBanner.activityBannerId) {
                    url = "/windeal/activity/banner/business/website/v1/update";
                } else {
                    url = "/windeal/activity/banner/business/website/v1/save";
                }

                ChuangShiOS.Util.request(props, {
                    url: Application.host + url,
                    data: data,
                    success: (response) => {
                        message.success({content: response.message, duration: 1});

                        props.onSubmit();
                    },
                    error: (response) => {
                        message.error({content: response.message, duration: 1});
                    },
                    complete: (response) => {
                        request.current = false;

                        setIsLoad(false);
                    },
                });
            })
            .catch((response) => {
                ChuangShiOS.Util.parseResponseError(response);
            });
    };

    return (
        <Modal
            title="活动广告"
            open={props.visible}
            centered
            width={ChuangShiOS.Util.getModalWidth()}
            bodyStyle={{
                backgroundColor: "#eff3f8",
                padding: "20px",
            }}
            cancelButtonProps={{
                icon: <CloseCircleOutlined />,
                size: "large",
            }}
            okButtonProps={{
                icon: <FileDoneOutlined />,
                size: "large",
            }}
            onCancel={handleCancelActivityBanner}
            onOk={handleSubmitActivityBanner}
            footer={
                <div className={Style.footer}>
                    <div className={Style.footer_space}></div>
                    <Space>
                        <Button icon={<CloseCircleOutlined />} size="large" onClick={handleCancelActivityBanner}>
                            取消
                        </Button>
                        <Button icon={<FileDoneOutlined />} type="primary" size="large" onClick={handleSubmitActivityBanner}>
                            提交
                        </Button>
                    </Space>
                </div>
            }
        >
            <div style={{height: ChuangShiOS.Util.getModalHeight() + "px"}} className={Style.page}>
                <ChuangShiOS.Content
                    className={Style.content}
                    isLoad={isLoad}
                    isEmpty={false}
                    isError={false}
                    marginLeft={0}
                    marginRight={0}
                    paddingTop={0}
                    paddingRight={0}
                    paddingBottom={0}
                    paddingLeft={0}
                >
                    <div className={Style.main}>
                        <Form form={form}>
                            <Row>
                                <Col span={24}>
                                    <Form.Item
                                        {...{
                                            labelCol: {flex: "12%"},
                                            wrapperCol: {flex: "auto"},
                                        }}
                                        label="广告图片"
                                        name="activityBannerImage"
                                        initialValue={0}
                                        rules={[
                                            {
                                                required: true,
                                                message: "请选择广告图片",
                                            },
                                        ]}
                                    >
                                        <ChuangShiOS.File fileType={"IMAGE"} limit={1} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <Form.Item
                                        {...{
                                            labelCol: {flex: "24%"},
                                            wrapperCol: {flex: "auto"},
                                        }}
                                        label="广告地址"
                                        name="activityBannerUrl"
                                        initialValue={""}
                                        rules={[
                                            {
                                                required: false,
                                                message: "请输入广告地址",
                                            },
                                        ]}
                                    >
                                        <Input className={Style.card_field} placeholder="请输入广告地址" onPressEnter={handleSubmitActivityBanner} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <Form.Item
                                        {...{
                                            labelCol: {flex: "24%"},
                                            wrapperCol: {flex: "auto"},
                                        }}
                                        label="广告排序"
                                        name="activityBannerSort"
                                        initialValue={0}
                                        rules={[
                                            {
                                                required: true,
                                                message: "请输入广告排序",
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            className={Style.card_field}
                                            min={0}
                                            max={999999}
                                            placeholder="请输入广告排序"
                                            onPressEnter={handleSubmitActivityBanner}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </ChuangShiOS.Content>
            </div>
        </Modal>
    );
};

BannerModal.propTypes = {
    visible: PropTypes.bool.isRequired,
    activityBanner: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

BannerModal.defaultProps = {};

export default BannerModal;
